import React from 'react';
import PropTypes from 'prop-types';
import JourneySearchDate from '../index';

const OutboundJourneySearchDate = ({
  booking,
  isReturnJourney,
  cheapestFares,
  currency,
  subscriptionStartDate,
  subscriptionEndDate,
  leg = [],
  isExchangingSingleLegOfSNCBSummated,
  testIdSuffix
}) => (
  <JourneySearchDate
    id="outbound"
    dateToChange="outboundDate"
    oppositeJourney={booking?.inbound || []}
    booking={booking}
    isReturnJourney={isReturnJourney}
    cheapestFares={cheapestFares}
    currency={currency}
    subscriptionStartDate={subscriptionStartDate}
    subscriptionEndDate={subscriptionEndDate}
    leg={leg}
    isExchangingSingleLegOfSNCBSummated={isExchangingSingleLegOfSNCBSummated}
    testIdSuffix={testIdSuffix}
  />
);

OutboundJourneySearchDate.propTypes = {
  booking: PropTypes.shape({
    inbound: PropTypes.array
  }),
  isReturnJourney: PropTypes.bool,
  cheapestFares: PropTypes.shape({
    cheapestFares: PropTypes.arrayOf(
      PropTypes.shape({
        date: PropTypes.string,
        price: PropTypes.number
      })
    )
  }),
  currency: PropTypes.string,
  subscriptionStartDate: PropTypes.string,
  subscriptionEndDate: PropTypes.string,
  leg: PropTypes.array,
  isExchangingSingleLegOfSNCBSummated: PropTypes.bool,
  testIdSuffix: PropTypes.string
};

export default OutboundJourneySearchDate;
